import React from 'react';

import { SortOption } from '@/entities';

import { MenuContainer, MenuItem } from './styled';

interface IFilterMenuProps {
  filerItems: SortOption[];
  selectedFilter: string;
  onFilterSelect: (filter: SortOption) => void;
}

export const FilterMenu: React.FC<IFilterMenuProps> = ({
  selectedFilter,
  onFilterSelect,
  filerItems
}) => {
  return (
    <MenuContainer>
      {filerItems.map((item) => (
        <MenuItem
          key={item}
          weight={1}
          selected={selectedFilter === item}
          onClick={() => onFilterSelect(item)}
        >
          {item}
        </MenuItem>
      ))}
    </MenuContainer>
  );
};
